import { createContext, useState, useCallback } from 'react';
import { ISupportUser } from 'domain/entities/SupportUser/SupportUser';

type SupportUserContext = {
    /** ログイン中のユーザー */
    user: ISupportUser | null;
    setUser: (user: ISupportUser) => void;
    resetUser: () => void;

    /** ログイン後に遷移するURL */
    urlAfterLogin: string;
    /** ログイン後URLを設定 */
    setUrlAfterLogin: (url: string) => void;
};

const defaultContext: SupportUserContext = {
    user: null,
    setUser: () => {},
    resetUser: () => {},
    urlAfterLogin: '/supporter/dashboard/',
    setUrlAfterLogin: () => {},
};

export const supportUserContext = createContext<SupportUserContext>(defaultContext);
export const useSupportUser = (): SupportUserContext => {
    const [user, setUser] = useState<ISupportUser | null>(null);
    const [urlAfterLogin, setUrlAfterLogin] = useState('/supporter/dashboard/');

    const resetUser = useCallback(async () => {
        setUser(null);
    }, []);

    return {
        user,
        setUser,
        resetUser,
        urlAfterLogin,
        setUrlAfterLogin,
    };
};
